import { createBaseStore } from '@/stores/api/base.js';
import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useProjectStore = defineStore('project', () => {
  const currentProject = ref(null);

  const {
    items: projects,
    fetchItems: fetch,
    createDetails,
    storeItem: store,
    updateItem: update,
    destroy,
  } = createBaseStore('projects');

  return {
    projects,
    currentProject,
    fetch,
    destroy,
    createDetails,
    update,
    store,
  };
});
